/* eslint-disable react/prop-types */
import { useState, useCallback, useRef, useContext, useEffect } from "react";
import { CustomFilter, CustomFloatingFilter, CustomPagination } from "../../../../shared";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import { UIContext, AuthContext } from "../../../../../contexts";
import { AgGridColumn, AgGridReact } from "ag-grid-react";

import { Pagination } from "@material-ui/lab";
import { Button } from "@material-ui/core";
import ROLES from "../../../../../constants/roles";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import getAgGridHeight from "../../../../../utils/commonFunctions/getAgGridHeight";
import {
	handleDateCellRenderer,
	handleNameCellRenderer,
	handleValueCellRenderer
} from "../../../../../utils/commonFunctions/cellRenderers";
import { EnrollmentApprovalProps } from "../../../../../@types/components/enrollmentProps.types";
import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import { Enrollment, EnrollmentStatusConstant } from "../../../../../@types/enrollment.types";
import { ENROLLMENT_STATUS } from "../../../../../constants/enrollment/enrollmentStatus";
import initCapitalize from "../../../../../utils/commonFunctions/initCapitalize";
import encryption from "../../../../../utils/commonFunctions/encryption";
import useRouteParam from "../../../../../hooks/useRouteParam";
import { useNavigate } from "react-router-dom";
import { useEnroller } from "../../../../../hooks";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import { dateTimeZoneConverter } from "../../../../../utils/commonFunctions/date";
import { GROUP_NUMBER } from "../../../../../constants/groups";
import { api } from "../../../../../utils/api";

// eslint-disable-next-line react/prop-types
const EnrollmentApprovalGrid = ({
	enrollments,
	currentPage,
	pageCount,
	handlePageChange,
	filterSchema,
	setFilterSchema
}: EnrollmentApprovalProps) => {
	const { isEnroller } = useEnroller();
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const [gridHeight, setGridHeight] = useState<string>("400px");
	const agGridRef = useRef<any>(null);
	const [isReadyForExport, setIsReadyForExport] = useState(false);
	const queryGroupNumber = useRouteParam("gn");
	const navigate = useNavigate();
	const { setDashboardHeader } = useContext(UIContext);
	const { user } = useContext(AuthContext);
	const [isExporting, setIsExporting] = useState(false);

	const handleAgGridReady = (params: GridReadyEvent) => {
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, agGridAPI, api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	// const handleExportButtonClick = useCallback(() => {
	// 	agGridRef?.current?.api.exportDataAsCsv({
	// 		fileName: "Enrollment Approvals.csv",
	// 		processCellCallback: (params: any) => {
	// 			// console.log("params", params);
	// 			switch (params.column.colId) {
	// 				case "employee": {
	// 					return params.value.first_name + " " + params.value.last_name;
	// 				}
	// 				case "enrollment_date": {
	// 					return dateTimeZoneConverter(params.value) as string;
	// 				}
	// 				default:
	// 					return params.value;
	// 			}
	// 		},
	// 		columnKeys: [
	// 			"employee.member_id",
	// 			"employee",
	// 			"plan_name",
	// 			"plan_code",
	// 			"enrollment_date",
	// 			"enrollment_status"
	// 		]
	// 	});
	// }, []);
	const handleExportButtonClick = useCallback(async () => {
		try {
			setIsExporting(true);
			// Cast filterSchema entries to proper type
			type FilterEntry = {
				value: string | null;
				type: string | null;
			};

			const filters = Object.fromEntries(
				Object.entries(filterSchema)
					.filter(([_, v]) => (v as FilterEntry).value !== null && (v as FilterEntry).value !== "")
					.map(([k, v]) => {
						const val = (v as FilterEntry).value;
						if (k === "employee.first_name") return ["first_name", val];
						if (k === "employee.last_name") return ["last_name", val];
						if (k === "employee.member_id") return ["member_id", val];
						return [k, val];
					})
			);

			// Fetch all enrollments from backend
			const response = await api.enrollments.getNotActiveEnrollmentsByGroup(
				queryGroupNumber as number,
				1, // page irrelevant
				0, // limit irrelevant
				filters,
				true // all=true
			);

			console.log("Rsponseexportchck--->>", response);

			if (!response) return;

			const allEnrollments = [
				...response.enrollments,
				...response.autoApproveEnrollments,
				...response.nonEnrollments
			];

			// Export fetched data
			agGridRef?.current?.api.setRowData(allEnrollments); // temporarily set data
			agGridRef?.current?.api.exportDataAsCsv({
				fileName: "Enrollment Approvals.csv",
				processCellCallback: (params: any) => {
					switch (params.column.colId) {
						case "employee":
							return params.value.first_name + " " + params.value.last_name;
						case "enrollment_date":
							return dateTimeZoneConverter(params.value) as string;
						default:
							return params.value;
					}
				},
				columnKeys: [
					"employee.member_id",
					"employee",
					"plan_name",
					"plan_code",
					"enrollment_date",
					"enrollment_status"
				]
			});

			// Reset grid back to paginated data
			agGridRef?.current?.api.setRowData(enrollments);
		} catch (error) {
			console.error(error);
		} finally {
			setIsExporting(false); // ⬅️ reset button
		}
	}, [queryGroupNumber, filterSchema, enrollments]);

	const handleLaunchClick = useCallback(() => {
		const focusedCell = agGridRef?.current?.api?.getFocusedCell();
		const row = agGridRef?.current?.api?.getDisplayedRowAtIndex(focusedCell.rowIndex);
		// console.log("Row", row) ;
		const {
			data: { plan_name, group_number, _id, insured_SSN, plan_code }
		} = row as { data: Enrollment };
		// console.log(plan_code, plan_name);
		// let pathname = "/employer/member";
		// if (group_number === GROUP_NUMBER.BBI_BROOKSHIRE_BROTHERS) {
		// 	if (plan_name === "Health Plan") {
		// 		pathname = `${pathname}/health-plan?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	} else if (plan_name === "Clinic Card") {
		// 		pathname = `${pathname}/clinic-card?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	} else if (plan_name === "Helping Our Own") {
		// 		pathname = `${pathname}/helping-our-own?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	} else if (plan_name === "Group Short Term Disability") {
		// 		pathname = `${pathname}/gstd-form?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	} else if (plan_name === "Christmas Club Election") {
		// 		pathname = `${pathname}/christmas-club?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	} else if (plan_name === "Group Long Term Disability(Class 2)") {
		// 		pathname = `${pathname}/lincoln-form?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	} else if (plan_name === "Group Life Insurance") {
		// 		pathname = `${pathname}/gli-form?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	} else if (plan_name === "KSOP") {
		// 		pathname = `${pathname}/ksop-form?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	}
		// } else if (group_number === GROUP_NUMBER.ICI_INTERCITY_INVESTMENTS) {
		// 	if (plan_name === "Health Plan") {
		// 		pathname = `${pathname}/intercity-health-plan-v2?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	} else if (plan_name === "Group Long Term Disability") {
		// 		pathname = `${pathname}/intercity-group-long-term-disability?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	}
		// } else if (group_number === GROUP_NUMBER.PROGRESSIVE_LABORATORIES) {
		// 	if (plan_name === "Health Plan") {
		// 		pathname = `${pathname}/progressive-labs-health-plan?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	}
		// } else if (group_number === GROUP_NUMBER.PANHANDLE_FIRST_BANK) {
		// 	if (plan_name === "Health Plan") {
		// 		pathname = `${pathname}/panhandle-health-plan?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	} else if (plan_name === "Dental Plan") {
		// 		pathname = `${pathname}/panhandle-dental-plan?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	} else if (plan_name === "Vision Plan") {
		// 		pathname = `${pathname}/panhandle-vision-plan?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	}
		// } else if (group_number === GROUP_NUMBER.TEST_GROUP) {
		// 	if (plan_name === "Health Plan") {
		// 		pathname = `${pathname}/test-group-health-plan?qs=${encryption(
		// 			insured_SSN
		// 		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}`;
		// 	}
		// }

		const pathname = `/employer/member/approval-plan-form?qs=${encryption(
			insured_SSN
		)}&&gn=${group_number}&&eid=${_id}&&pc=${plan_code}&&pn=${plan_name}`;
		navigate(pathname);
	}, [navigate]);

	const handleActionCellRender = useCallback(
		({ value }: { value: any }) => {
			return (
				<>
					{value === "SUBMITTED" || value === "ACTIVE" ? (
						<Button className="ag-grid-cell-button " variant="outlined" onClick={handleLaunchClick}>
							Launch
						</Button>
					) : (
						"N/A"
					)}
				</>
			);
		},
		[handleLaunchClick]
	);
	const isFilterApplied = Object.values(filterSchema).some((f: any) => f.value !== "" && f.value !== null);

	const handleEnrollmentStatusCellRenderer = useCallback(({ value }: { value: string }) => {
		return (
			<div>{initCapitalize(ENROLLMENT_STATUS[value.toLocaleLowerCase() as keyof EnrollmentStatusConstant])}</div>
		);
	}, []);

	useEffect(() => {
		const _gridHeight = getAgGridHeight(enrollments.length);
		if (enrollments.length !== 0) {
			setIsReadyForExport(true);
		}
		setGridHeight(_gridHeight);
	}, [enrollments.length]);

	return (
		<>
			<div className="enroll-approval-grid-container glb-tab-grid-container" id="enroll-approval-grid-container">
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						rowData={enrollments}
						onGridReady={handleAgGridReady}
						onFirstDataRendered={handleFirstDataRendered}
						rowSelection={"Single"}
						animateRows
						suppressColumnVirtualisation={true}
						defaultColDef={{
							filter: "agTextColumnFilter",
							floatingFilter: true,
							resizable: true
						}}
						frameworkComponents={{
							handleActionCellRender: handleActionCellRender,
							handleDateCellRenderer: handleDateCellRenderer,
							handleEnrollmentStatusCellRenderer: handleEnrollmentStatusCellRenderer,
							handleNameCellRenderer: handleNameCellRenderer,
							handleValueCellRenderer: handleValueCellRenderer,
							customFloatingFilter: CustomFloatingFilter,
							customFilter: CustomFilter,
							schema: filterSchema,
							setPayloadSchema: setFilterSchema
						}}
					>
						{user &&
						user.role === ROLES.super_admin &&
						((user.first_name === "Chitrak" && user.last_name === "Biswas") ||
							(user.first_name === "Anupam" && user.last_name === "Biswas") ||
							(user.first_name === "Rahul" && user.last_name === "Dutta") ||
							(user.first_name === "Suman" && user.last_name === "Dutta")) ? (
							<AgGridColumn
								field="group_number"
								headerName="Group Number"
								floatingFilterComponentParams={{ suppressFilterButton: true }}
								suppressSizeToFit
							></AgGridColumn>
						) : null}
						<AgGridColumn
							field="employee.member_id"
							onCellClicked={handleLaunchClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
							headerName="Employee Id"
							// floatingFilterComponentParams={{ suppressFilterButton: true }}
							suppressSizeToFit
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
						></AgGridColumn>
						<AgGridColumn
							field="employee.first_name"
							headerName="First Name"
							onCellClicked={handleLaunchClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
							// floatingFilterComponentParams={{ suppressFilterButton: true }}
							// cellRenderer="handleNameCellRenderer"
							suppressSizeToFit
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
						></AgGridColumn>
						<AgGridColumn
							field="employee.last_name"
							headerName="Last Name"
							onCellClicked={handleLaunchClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
							// floatingFilterComponentParams={{ suppressFilterButton: true }}
							// cellRenderer="handleNameCellRenderer"
							suppressSizeToFit
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
						></AgGridColumn>
						<AgGridColumn
							field="employee.location_number"
							headerName="Location Number"
							floatingFilter={false}
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleValueCellRenderer"
							suppressSizeToFit
						></AgGridColumn>
						<AgGridColumn
							field="plan_name"
							headerName="Plan Name"
							floatingFilter={false}
							// floatingFilterComponentParams={{ suppressFilterButton: true }}
							suppressSizeToFit={true}
							// floatingFilterComponent="customFloatingFilter"
							// filter="customFilter"
						></AgGridColumn>
						{/* <AgGridColumn
							field="plan_code"
							headerName="Plan Code"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
						></AgGridColumn> */}
						<AgGridColumn
							field="enrollment_date"
							headerName="Submit Date"
							cellRenderer="handleDateCellRenderer"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							// floatingFilterComponentParams={{ suppressFilterButton: true }}
							suppressSizeToFit
						></AgGridColumn>
						<AgGridColumn
							field="enrollment_status"
							headerName="Status"
							cellRenderer="handleEnrollmentStatusCellRenderer"
							suppressSizeToFit={true}
							floatingFilter={false}
							floatingFilterComponentParams={{ suppressFilterButton: true }}
						></AgGridColumn>
						<AgGridColumn
							field="plan_code"
							headerName="Plan Code"
							floatingFilter={false}
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							suppressSizeToFit
						></AgGridColumn>
						{isEnroller ? null : (
							<AgGridColumn
								field="enrollment_status"
								headerName="Action"
								cellRenderer="handleActionCellRender"
								filter={false}
								suppressSizeToFit={true}
								floatingFilterComponentParams={{ suppressFilterButton: true }}
							></AgGridColumn>
						)}
					</AgGridReact>
				</div>
				{isReadyForExport ? (
					<div className="pf-action-button-container mg-top-20 mg-right-ve10" id="pf-action-button-container">
						<Button
							className="button-green"
							variant="contained"
							onClick={handleExportButtonClick}
							disabled={isExporting}
						>
							<span className="button-label-with-icon">
								{isExporting ? "Downloading…" : isFilterApplied ? "Export Filtered Data" : "Export All"}
							</span>

							{!isExporting && (
								<span>
									<ImportExportIcon className="button-icon" />
								</span>
							)}
						</Button>
					</div>
				) : null}
			</div>
			<div className="custom-pagination" id="custom-pagination">
				<CustomPagination pageCount={pageCount} currentPage={currentPage} handlePageChange={handlePageChange} />
			</div>
		</>
	);
};

export default EnrollmentApprovalGrid;
